import type { Control, FieldValues, Path } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';
import { TEXTAREA_CONTROL_CLASS } from '@/styles/fieldControl';
import { FormFieldLabel } from './FormFieldLabel';
import { FULL_ROW_FIELD_CLASS } from './formDialog.constants';

interface FormTextareaFieldProps<TValues extends FieldValues> {
  control: Control<TValues>;
  name: Path<TValues>;
  label: string;
  placeholder?: string | undefined;
  maxLength?: number | undefined;
  hasCharacterCount?: boolean | undefined;
  isRequired?: boolean | undefined;
  isFullRow?: boolean | undefined;
}

export function FormTextareaField<TValues extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  maxLength,
  hasCharacterCount = false,
  isRequired = false,
  isFullRow = false,
}: FormTextareaFieldProps<TValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(isFullRow && FULL_ROW_FIELD_CLASS)}>
          <FormFieldLabel
            label={label}
            isRequired={isRequired}
            countedValue={field.value}
            characterLimit={hasCharacterCount ? maxLength : undefined}
          />
          <FormControl>
            <Textarea
              {...field}
              placeholder={placeholder}
              maxLength={maxLength}
              aria-required={isRequired || undefined}
              className={TEXTAREA_CONTROL_CLASS}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
